<template>
    <v-container>
        <v-row v-if="esMovil">
            <v-col cols="12">
                <IndicadorCard
                    v-for="indicador in listaIndicadores"
                    :key="indicador.id"
                    :indicador="indicador"
                    class="my-3"
                >
                </IndicadorCard>
            </v-col>
            <v-col cols="12" v-if="!esUltimaPagina">
                <!--Cuando se muestra este card, carga mas indicadores-->
                <v-card v-intersect="cargarMasIndicadores" class="mx-auto">
                    <v-skeleton-loader type="card"></v-skeleton-loader>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="6">
                <IndicadorCard
                    v-for="indicador in listaIndicadoresImpar"
                    :key="indicador.id"
                    :indicador="indicador"
                    class="my-3"
                >
                </IndicadorCard>
            </v-col>
            <v-col cols="6">
                <IndicadorCard
                    v-for="indicador in listaIndicadoresPar"
                    :key="indicador.id"
                    :indicador="indicador"
                    class="my-3"
                >
                </IndicadorCard>
            </v-col>
            <v-col cols="6" v-if="!esUltimaPagina">
                <!--Cuando se muestra este card, carga mas indicadores-->
                <v-card v-intersect="cargarMasIndicadores" class="mx-auto">
                    <v-skeleton-loader type="card"></v-skeleton-loader>
                </v-card>
            </v-col>
            <v-col cols="6" v-if="!esUltimaPagina">
                <!--Cuando se muestra este card, carga mas indicadores-->
                <v-card class="mx-auto">
                    <v-skeleton-loader type="card"></v-skeleton-loader>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import IndicadorCard from "@components/IndicadorCard.vue";

export default {
    name: "listaIndicadores",
    props: {
        listaIndicadores: {
            type: Array,
            required: true,
        },
        esUltimaPagina: {
            type: Boolean,
            default: true,
        },
    },
    components: { IndicadorCard },
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },

        listaIndicadoresPar() {
            return this.listaIndicadores.filter((v, i) => i % 2);
        },
        listaIndicadoresImpar() {
            return this.listaIndicadores.filter((v, i) => !(i % 2));
        },
    },
    methods: {
        cargarMasIndicadores() {
            this.$emit("cargarMasIndicadores");
        },
    },
};
</script>
